// extracted by mini-css-extract-plugin
export default {"modal":"AcquiredModal_modal__1h-cT"};